import api from 'shared/api';

export const revokeFeatureDevice = (featureID, deviceID) => {
  const url = `/api/v1/license-product-features/${featureID}/release_device/`;
  return api.post(url, { device: deviceID });
};

export const borrowFloatingFeatureDevice = (featureID, data) => {
  const url = `/api/v1/license-product-features/${featureID}/borrow_device/`;
  return api.post(url, data);
};

export const releaseFloatingFeatureBorrowedDevice = (featureID, data) => {
  const url = `/api/v1/license-product-features/${featureID}/borrow_release_device/`;
  return api.post(url, data);
};
